var render = function render(){var _vm=this,_c=_vm._self._c;return _c('full-calendar',{attrs:{"events":_vm.events,"config":_vm.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }